import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaGithub, FaLinkedin, FaInstagram, FaEnvelope, FaBars, FaTimes } from 'react-icons/fa';

const Navbar = () => {
  const [showProfile, setShowProfile] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const homeSection = document.getElementById('home');
      if (homeSection) {
        const homeBottom = homeSection.offsetTop + homeSection.offsetHeight;
        setShowProfile(window.scrollY > homeBottom);
      }
    };

    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setIsMenuOpen(false); // Close menu when switching to a bigger screen
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleResize); // Listen for screen size changes

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setIsMenuOpen(false);
  };

  return (
    <motion.nav 
      initial={{ opacity: 0, y: -20 }} 
      animate={{ opacity: 1, y: 0 }} 
      transition={{ duration: 0.5, ease: 'easeInOut' }}
      className="fixed top-0 left-0 w-full flex justify-between items-center px-6 md:px-16 py-4 bg-gradient-to-r from-blue-900 via-purple-800 to-blue-600 text-white shadow-lg z-50 transition-all duration-500 ease-in-out"
    >
      {/* Profile and Name */}
      <div className="flex items-center space-x-4 transition-all duration-500 ease-in-out">
        {showProfile && (
          <motion.img 
            src="/profile.jpg" 
            alt="Profile" 
            className="w-10 h-10 md:w-14 md:h-14 object-cover border-2 border-white rounded-full"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, ease: 'easeInOut' }}
          />
        )}
        <h1 className="font-bold text-lg md:text-xl">Nachiketa Kumar</h1>
      </div>

      {/* Mobile Menu Toggle */}
      <div className="md:hidden">
        <button onClick={() => setIsMenuOpen(!isMenuOpen)}>
          {isMenuOpen ? <FaTimes className="text-2xl" /> : <FaBars className="text-2xl" />}
        </button>
      </div>

      {/* Navbar Links */}
      <ul className={`md:flex space-x-10 text-lg font-medium transition-all duration-500 ease-in-out 
        ${isMenuOpen ? 'absolute top-16 left-1/2 transform -translate-x-1/2 w-[90%] bg-blue-900 flex flex-col justify-center items-center py-6 space-y-6 rounded-lg shadow-lg' 
        : 'hidden md:flex'}`}>
        <li className="cursor-pointer hover:text-yellow-300" onClick={() => scrollToSection('home')}>Home</li>
        <li className="cursor-pointer hover:text-yellow-300" onClick={() => scrollToSection('about')}>About</li>
        <li className="cursor-pointer hover:text-yellow-300" onClick={() => scrollToSection('projects')}>Projects</li>
        <li className="cursor-pointer hover:text-yellow-300" onClick={() => scrollToSection('skills')}>Skills</li>
        <li className="cursor-pointer hover:text-yellow-300" onClick={() => scrollToSection('achievements')}>Achievements</li>
      </ul>

      {/* Social Icons */}
      <div className="hidden md:flex space-x-5 text-2xl transition-all duration-500 ease-in-out">
        <a href="https://github.com/NachiketaKr" target="_blank" rel="noopener noreferrer">
          <FaGithub className="cursor-pointer hover:text-yellow-300 transition-all duration-300" />
        </a>
        <a href="https://linkedin.com/in/nachiketa-kr" target="_blank" rel="noopener noreferrer">
          <FaLinkedin className="cursor-pointer hover:text-yellow-300 transition-all duration-300" />
        </a>
        <a href="https://instagram.com/nachiketa_kr" target="_blank" rel="noopener noreferrer">
          <FaInstagram className="cursor-pointer hover:text-yellow-300 transition-all duration-300" />
        </a>
        <a href="mailto:nachiketakumar.iitd@gmail.com" target="_blank" rel="noopener noreferrer">
          <FaEnvelope className="cursor-pointer hover:text-yellow-300 transition-all duration-300" />
        </a>
      </div>
    </motion.nav>
  );
};

export default Navbar;
